/**
 * Validates that a geonameId is a non-empty string of digits only.
 * Mirrors the validation enforced by location-view-api (commit 8ba5e16).
 */
const isValidGeonameId = (geonameId: string | undefined): boolean =>
  typeof geonameId === 'string' && /^\d+$/.test(geonameId);

export default isValidGeonameId;
